import { css } from '@mui/material/styles';
export const menuComponentOverrides = {
    MuiMenu: {
        defaultProps: {
            disableScrollLock: true
        },
        styleOverrides: {
            root: () => css `
                & ul {
                    min-width: 10rem;
                    max-width: 18.75rem;
                }
            `
        }
    },
    MuiMenuItem: {
        defaultProps: {
            disableRipple: true
        },
        styleOverrides: {
            root: ({ theme }) => css `
                border: unset;
                background: unset;
                text-decoration: unset;
                outline:  unset;

                box-sizing: border-box;

                cursor: pointer;
                position: relative;
                color: ${theme.tokens.FuelColorTextPrimary};
                font-family: ${theme.tokens.FuelFontFamilyBase};
                font-size: ${theme.tokens.FuelFontSizeSm};
                line-height: ${theme.tokens.FuelLineHeightBase};
                text-align: start;

                width: 100%;
                display: flex;
                align-items: center;
                gap: ${theme.tokens.FuelSpacing2};
                padding-inline: ${theme.tokens.FuelSpacing4};
                padding-block: ${theme.tokens.FuelSpacing2};

                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;

                &:hover, &:focus-visible {
                    background-color: ${theme.tokens.FuelColorBackgroundActionDefaultHovered};
                }

                &:active {
                    background-color: ${theme.tokens.FuelColorBackgroundActionDefaultPressed};
                }

                &:focus-visible {
                    box-shadow: var(--menu-item-outline-focus);
                }
            `,
            selected: ({ theme }) => css `
                color: ${theme.tokens.FuelColorBrandPrimary};
                background-color: ${theme.tokens.FuelColorBackgroundActionDefaultSelected};

                &::after {
                    content: "";
                    position: absolute;
                    width: 3px;
                    height: 100%;
                    left: 0;
                    top: 0;
                    background-color: ${theme.tokens.FuelColorBackgroundActionDefaultSelectedBar};
                }
            `,
            divider: ({ theme }) => css `
                justify-content: space-between;
                border-bottom: 0.50px ${theme.tokens.FuelColorBorderBase} solid;
            `
        }
    }
};
